import { NodeViewWrapper, NodeViewProps, NodeViewContent } from '@tiptap/react';
import { motion } from 'framer-motion';
import { Box, VStack } from '@chakra-ui/react';
import {
  ConversationMessage,
  ConversationMessagePersona,
} from '@duke-hq/ui/components/Conversation/ConversationMessage';

const blockAnimationDuration = 0.8;

const DUKE_FALLBACK: ConversationMessagePersona = { name: 'Duke', avatarUrl: null };

function personaIdOf(node: { attrs?: { personaId?: unknown } } | null | undefined): string | null {
  if (!node) {
    return null;
  }
  return typeof node.attrs?.personaId === 'string' ? node.attrs.personaId : '';
}

export function DBlockNodeViewStudent(
  props: NodeViewProps & { getPersonaById: (personaId: string) => ConversationMessagePersona },
) {
  const { node, getPersonaById } = props;

  const personaId = personaIdOf(node) ?? '';
  const persona = personaId.length > 0 ? getPersonaById(personaId) : DUKE_FALLBACK;

  // Grouping is precomputed and stamped onto the block attrs (see withGrouping)
  // so it stays correct as later same-speaker blocks are appended.
  const showName = node.attrs?.showName !== false;
  const showAvatar = node.attrs?.showAvatar !== false;

  // `animation` is false in "skip animation" mode, so the block renders instantly
  // without the fade-in.
  const animate = node.attrs?.animation !== false;

  const message = (
    <ConversationMessage persona={persona} showName={showName} showAvatar={showAvatar}>
      <NodeViewContent className="content" />
    </ConversationMessage>
  );

  // A plain wrapper (not the canvas `content-bubble` class): the preview's
  // visuals all come from ConversationMessage.
  return (
    <NodeViewWrapper>
      <VStack
        align="flex-start"
        justify="center"
        width="100%"
        spacing={0}
        onClick={(ev) => {
          ev.stopPropagation();
          return false;
        }}
      >
        {animate ? (
          <motion.div
            style={{ width: '100%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: blockAnimationDuration,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {message}
          </motion.div>
        ) : (
          <Box width="100%">{message}</Box>
        )}
      </VStack>
    </NodeViewWrapper>
  );
}
